import { useField } from "formik";
import React, { ChangeEvent, FC, ReactNode } from "react";

import { FormInputLayout } from "./form_input_layout";

type FileFieldProps = Omit<
  React.ComponentPropsWithoutRef<"input"> & {
    name: string;
    label: string;
    accept?: string;
    helpElement?: ReactNode;
  },
  "type"
>;

const FileField: FC<FileFieldProps> = ({
  id,
  name,
  label,
  required,
  helpElement,
  accept,
  ...rest
}) => {
  const [_field, _meta, helpers] = useField(name);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.currentTarget.files;
    if (files) {
      helpers.setValue(files[0]);
      helpers.setTouched(true);
    }
  };

  const fieldElement = (
    <input
      id={id ?? name}
      type="file"
      name={name}
      onChange={handleChange}
      accept={accept}
      required={required}
      {...rest}
    />
  );
  return (
    <FormInputLayout
      name={name}
      fieldElement={fieldElement}
      helpElement={helpElement}
      label={label}
    />
  );
};

export { FileField, FileFieldProps };
